import appConstants from "../../../../../../appConstants";
import {
  MultiSelectFilter,
  DateTimeFilter
} from '@dataGrid/components/columnFilters';
import { formatDateTime, mergeUserConfig } from '@dataGrid/gridUtilities';
import { IBETARenderer } from '@dataGrid/components/cellRenderer';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration({ userConfig, terminal }) {
    const defaultConfig = GridConfig.getDefaultConfiguration({ terminal });
    return mergeUserConfig({
      defaultConfig,
      userConfig
    });
  }

  static getDefaultConfiguration({ terminal }) {
    return {
      title: appConstants.gridNames.TrailerStripPriorityGrid,
      keyColumn: "trailerNumber",
      rowSelection: "multiple",
      rowDeselection: true,
      columns: [
        {
          headerName: "Un R",
          headerTooltip: "Unloading Ranking",
          pinned: "left",
          field: "unldgRanking",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_62,
          maxWidth: appConstants.columnWidth.W_80,
          printColWidth: appConstants.columnWidth.W_40,
          lockPosition: true,
          lockPinned: true,
        },
        {
          headerName: "Trailer #",
          headerTooltip: "Trailer #",
          field: "trailerNumber",
          pinned: "left",
          width: appConstants.columnWidth.W_110,
          minWidth: appConstants.columnWidth.W_110,
          printColWidth: appConstants.columnWidth.W_80,    
          lockPosition: true,
          lockPinned: true,
          filter: MultiSelectFilter,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Current Status",
          headerTooltip: "Current Status",
          field: "shipmentStatus",
          pinned: "left",
          width: appConstants.columnWidth.W_120,
          minWidth: appConstants.columnWidth.W_120,
          lockPosition: true,
          lockPinned: true,
          filter: MultiSelectFilter,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "IB ETA",
          headerTooltip: "IB ETA",
          field: "ibeta",
          minWidth: appConstants.columnWidth.W_100,
          printColWidth: appConstants.columnWidth.W_80,
          valueFormatter: formatDateTime,
          cellRenderer: IBETARenderer,
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME,
          },
        },
        {
          headerName: "APT",
          headerTooltip: "APT Shipments",
          field: "aptShipments",
          minWidth: appConstants.columnWidth.W_80,
          printColWidth: appConstants.columnWidth.W_30,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Priority",
          field: "priorityShipments",
          cellClass: "gridCell-leftAlign",
          headerTooltip: "Priority Bills",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_70,
          printColWidth: appConstants.columnWidth.W_50,
        },
        {
          headerName: `${terminal} Bills`,
          field: "terminalShipments",
          cellClass: "gridCell-leftAlign",
          headerTooltip: "Total Terminal Bills",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
          printColWidth: appConstants.columnWidth.W_30,
        },
        {
          headerName: "Ttl Bills",
          field: "totalShipments",
          cellClass: "gridCell-leftAlign",
          headerTooltip: "Total Bills",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_70,
          printColWidth: appConstants.columnWidth.W_30,
        },
        {
          headerName: "Door",
          field: "door",
          cellClass: "gridCell-leftAlign",
          headerTooltip: "Door",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_70,
          printColWidth: appConstants.columnWidth.W_30,
        },
        {
          headerName: "Curr Term",
          headerTooltip: "Current Terminal",
          field: "currentTerminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
          printColWidth: appConstants.columnWidth.W_50,
        },
        {
          headerName: "Next Term",
          headerTooltip: "Next Terminal",
          field: "nextTerminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
          printColWidth: appConstants.columnWidth.W_50,
        },
        {
          headerName: "Dest Term",
          headerTooltip: "Destination Terminal",
          field: "destTerminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
          printColWidth: appConstants.columnWidth.W_50,
        },
        {
          headerName: "Orig Term",
          headerTooltip: "Origin Terminal",
          field: "originTerminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
          printColWidth: appConstants.columnWidth.W_50,
        }
      ],
    };
  }
}
